import { useEffect } from 'react';

interface UseCatalogListScrollResetParams {
  scrollParent: HTMLElement | null;
  hasSnapshot: boolean;
}

export const useCatalogListScrollReset = ({
  scrollParent,
  hasSnapshot,
}: UseCatalogListScrollResetParams) => {
  useEffect(() => {
    if (!scrollParent || hasSnapshot) {
      return;
    }

    scrollParent.scrollTop = 0;
  }, [scrollParent]);
};
